module.exports = __webpack_public_path__ + "static/media/euro-white.2d1240ed.svg";